import { Component, ViewChild } from "@angular/core";
import { BusinessDevelopmentAccountTypeModel, IBusinessDevelopmentAccountTypeModel } from "@models";
import { SlickDialogComponent } from "slick-components";
import { LookupService, SleepService } from "@services";

@Component({
    selector: "business-development-account-types-dialog",
    templateUrl: "business-development-account-types-dialog.component.html",
    standalone: false
})
export class BusinessDevelopmentAccountTypesDialogComponent {
	@ViewChild("dialogRef") dialogRef: SlickDialogComponent;
	resolve: any;

	isSubmitted: boolean = false;
	spinnerStatus: string;
	accountTypes: IBusinessDevelopmentAccountTypeModel[] = [];

	constructor(private lookupService: LookupService) {
	}

	async showDialog(): Promise<IBusinessDevelopmentAccountTypeModel[]> {
		this.isSubmitted = false;
		this.spinnerStatus = "reset";
		this.accountTypes = null;

		return new Promise<IBusinessDevelopmentAccountTypeModel[]>(async (resolve) => {
			this.accountTypes = await this.lookupService.getBusinessDevelopmentAccountTypes();
			this.resolve = resolve;

			this.dialogRef.showDialog();
		});
	}

	addNewAccountType() {
		this.accountTypes = [...this.accountTypes, new BusinessDevelopmentAccountTypeModel()];
	}

	async onSave() {
		this.isSubmitted = true;
		let isValid = true;
		
		this.accountTypes = this.accountTypes.filter(x => x.businessDevelopmentAccountTypeId > 0 || (x.businessDevelopmentAccountTypeId === 0 && x.description));

		this.accountTypes.forEach(accountType => {
			if (accountType.businessDevelopmentAccountTypeId > 0 && !accountType.description)
				isValid = false;
		});

		if (!isValid) {
			this.spinnerStatus = "error";
			return;
		}

		try {
			this.spinnerStatus = "spin";

			await SleepService.sleep(500);
			this.accountTypes = await this.lookupService.updateBusinessDevelopmentAccountTypes(this.accountTypes);

			this.spinnerStatus = "ok";
			await SleepService.sleep(500);

			this.resolve(this.accountTypes);
			this.dialogRef.hideDialog();
		}
		catch {
			this.spinnerStatus = "error";
		}
	}

	async onCancel() {
		this.resolve(null);
		this.dialogRef.hideDialog();
	}
}

